import React, { useState } from "react";
import styled from "styled-components"
import ContentWidth from "./ContentWidth";
import colors from "../styles/colors"
// import text from "../styles/text"
import media from "../styles/media"

const Tabs = ({ content }) => {
  const [currentTab, setCurrentTab] = useState(1);
  const [currentTabData, setCurrentTabData] = useState({
    id: content.columns[0].id,
    bodyCopy: content.columns[0].bodyCopy,
    bodyImage: content.columns[0].bodyImage,
  });

  const handleTabClick = (tab, index) => {
    setCurrentTab(index + 1);
    setCurrentTabData(tab);
  };

  return (
    <ContentWidth>
      <TabsNavContainer>
        {content.columns.map((tab, index) => (
          <Tab key={tab.index}>
            <Button
              id={tab.index}
              disabled={currentTab === tab.index}
              onClick={() => handleTabClick(tab, index)}
            >
              {tab.title}
            </Button>
          </Tab>
        ))}
      </TabsNavContainer>
        <TabContainer>
          {currentTab && (
            <FlexContainer>
                <FeaturedImage
                  src={
                    currentTabData.bodyImage
                      ? currentTabData.bodyImage.sourceUrl
                      : ""
                  }
                  max
                  alt={currentTabData.bodyImage}
                />
              <TabContentContainer>
                <TabContent dangerouslySetInnerHTML={{ __html: currentTabData.bodyCopy }} />
              </TabContentContainer>
            </FlexContainer>
          )}
        </TabContainer>
    </ContentWidth>
  );
};

const TabsNavContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12.5vw;

  ${media.fullWidth} {
    gap: 180px;
  }
  
  ${media.tablet} {
    gap: 17.578vw;
  }
  
  ${media.mobile} {
    flex-direction: column;
    margin-bottom: 7.009vw;
  }
`
const FlexContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-top: 2.083vw;
  border-top: 0.139vw solid ${colors.primaryPurple};
  gap: 4.375vw;

  ${media.fullWidth} {
    padding-top: 30px;
    border-top: 2px solid ${colors.primaryPurple};
    gap: 63px;
  }
  
  ${media.tablet} {
    padding-top: 2.93vw;
    border-top: 0.195vw solid ${colors.primaryPurple};
    gap: 6.152vw;
  }
  
  ${media.mobile} {
    flex-direction: column;
  }
`
const Tab = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.grey700};
  font-family: Archivo, sans;
  width: auto;
  font-weight: 700;
  font-size: 1.25vw;
  height: 5.139vw;
  padding: 1.736vw;

  ${media.hover} {
    :hover {
      border-top: 2px solid ${colors.primaryPurple};
    }
  }

  ${media.fullWidth} {
    font-size: 18px;
    height: 74px;
    padding: 25px;
  }
  
  ${media.tablet} {
    font-size: 1.758vw;
    height: 7.227vw;
    padding: 2.441vw;
  }
  
  ${media.mobile} {
    font-size: 4.206vw;
  }
`
const Button = styled.button``

const TabContainer = styled.div`

`
const FeaturedImage = styled.img`
  width: 27.778vw;

  ${media.fullWidth} {
    width: 400px;
  }
  
  ${media.tablet} {
    width: 39.063vw;
  }
  
  ${media.mobile} {
    align-self: flex-start;
    margin-top: 9.346vw;
  }
`
const TabContentContainer = styled.div`
    display: flex;
    align-self: start;
    width: 34.375vw;

    ${media.fullWidth} {
      width: 495px;
    }
    
    ${media.tablet} {
      width: auto;
    }
    
    ${media.mobile} {
      width: 80vw;
    }
`
const TabContent = styled.div`
  h3, h2 {
    font-weight: 700;
    font-size: 40px;
    line-height: 48px;
    margin-bottom: 20px;

    ${media.desktop} {
      font-size: 2.778vw;
      line-height: 3.333vw;
      margin-bottom: 1.389vw;
    }
    
    ${media.tablet} {
      font-weight: 700;
      font-size: 3.906vw;
      line-height: 4.688vw;
      width: 33.594vw;
    }
    
    ${media.mobile} {
    
    }
  }

  p {
     font-family: Archivo, sans;
     font-size: 20px;
     line-height: 30px;
     margin-bottom: 6px;
     color: ${colors.gray700};
     margin: 16px 0;

    ${media.desktop} {
      font-size: 1.389vw;
      line-height: 2.083vw;
      margin: 1.111vw 0;
    }
    
    ${media.tablet} {
      font-size: 2.344vw;
      line-height: 2.93vw;
      margin-bottom: 0.586vw;
      width: 30.664vw;
    }
    
    ${media.mobile} {
    
    }
  }
  a {
    ${media.hover} {
      :hover{
        text-decoration: underline;
      }
    }
  }
`
export default Tabs;
